/* @flow */

import * as React from 'react';
import { inject, observer } from 'mobx-react';

import { translate } from 'react-i18next';
import type { TranslatorProps } from 'react-i18next';

import type TypeActionDrawerStore from 'stores/ActionDrawerStore.js';
import ActionDrawerBlock from 'views/ActionDrawer/components/ActionDrawerBlock/ActionDrawerBlock';
import ActionDrawerTable from 'views/ActionDrawer/components/ActionDrawerTable/ActionDrawerTable';
import ActionDrawerFormButtons from 'views/ActionDrawer/components/ActionDrawerFormButtons/ActionDrawerFormButtons';
import ElectroSelectWithOther from '../../../../../../forms/components/inputs/ElectroSelectWithOther/ElectroSelectWithOther';
import ElectroRadioGroup from 'forms/components/inputs/ElectroRadioGroup/ElectroRadioGroup';
import styles from '../../../../ActionDrawer.module.scss';
import Form from '../../../../../../forms/_.extend';

type TypeProps = {
  user: Object,
  form: Form,
  currentAccountDetails: Object,
  actionDrawerStore: TypeActionDrawerStore,
} & TranslatorProps;

@translate()
@inject('actionDrawerStore')
@observer
export default class ChangeUserRoleForm extends React.Component<*> {
  render(): React.Node {
    const { t }: TranslatorProps = this.props;
    const { user, form, currentAccountDetails }: TypeProps = this.props;

    const accountDetails = [
      [
        t('general:trading_account'),
        `${currentAccountDetails.name} ${currentAccountDetails.account_no}`,
      ],
      [t('general:name'), `${user.first_name} ${user.last_name}`],
      [t('general:roles.labels.current_role'), t(`general:roles.${user.role_id}`)],
    ];

    return (
      <React.Fragment>
        <div className={styles['action-drawer-content']}>
          <ActionDrawerBlock
            divider={true}
            gutters={true}
            heading={t('general:users.labels.details')}
          >
            <ActionDrawerTable data={accountDetails} />
          </ActionDrawerBlock>
          <ActionDrawerBlock
            divider={true}
            gutters={true}
            heading={t('general:actions.change_user_role_to')}
          >
            <ElectroRadioGroup field={form.$('changeUserRoleForm.userRole')} secondaryKey="hint" />
          </ActionDrawerBlock>
          <ActionDrawerBlock divider={false} gutters={true}>
            <ElectroSelectWithOther
              field={form.$('changeUserRoleForm.reason')}
              otherHeading={`${t('general:reasons.provide_reason')} *`}
            />
          </ActionDrawerBlock>
        </div>
        <ActionDrawerFormButtons form={form} submitTxt={t('general:actions.change_role')} />
      </React.Fragment>
    );
  }
}
